var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { convert } from "./converter";
export class ConvertingMediaRecorder extends MediaRecorder {
    static isTypeSupported(type) {
        if (type === 'video/mp4') {
            if (MediaRecorder.isTypeSupported('video/mp4'))
                return true;
            if (!MediaRecorder.isTypeSupported('video/webm;codecs="avc1,opus"')) {
                console.log("Warning: device doesn't support codec required for @zappar/mediarecorder remuxing ('video/webm;codecs=\"avc1,opus\"')");
                return false;
            }
            else
                return true;
        }
        return MediaRecorder.isTypeSupported(type);
    }
    constructor(stream, options) {
        let needsConversion = false;
        let mimeType = options === null || options === void 0 ? void 0 : options.mimeType;
        if (mimeType === 'video/mp4') {
            if (!MediaRecorder.isTypeSupported('video/mp4')) {
                if (!MediaRecorder.isTypeSupported('video/webm;codecs="avc1,opus"')) {
                    console.log("Warning: device doesn't support codec required for @zappar/mediarecorder remuxing ('video/webm;codecs=\"avc1,opus\"')");
                }
                else {
                    needsConversion = true;
                    mimeType = 'video/webm;codecs="avc1,opus"';
                }
            }
        }
        super(stream, Object.assign(Object.assign({}, options), { mimeType }));
        this._needsConversion = false;
        this._capturedData = [];
        this._dataAvailableListeners = new Set();
        this._stopListeners = new Set();
        this._ondataavailable = null;
        this._onstop = null;
        this._needsConversion = needsConversion;
        if (needsConversion) {
            this.addEventListener('dataavailable', ev => {
                this._capturedData.push(ev.data);
            });
            this.addEventListener('stop', (ev) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const blob = new Blob(this._capturedData);
                const arr = yield blob.arrayBuffer();
                const converted = yield convert(arr);
                (_a = this._ondataavailable) === null || _a === void 0 ? void 0 : _a.call(this, new BlobEvent('dataavailable', {
                    data: new Blob([converted], { type: 'video/mp4' }),
                    timecode: performance.now()
                }));
                for (const entry of this._dataAvailableListeners.values()) {
                    entry.call(this, new BlobEvent('dataavailable', {
                        data: new Blob([converted], { type: 'video/mp4' }),
                        timecode: performance.now()
                    }));
                }
                ;
                (_b = this._onstop) === null || _b === void 0 ? void 0 : _b.call(this, new Event('stop'));
                for (const entry of this._stopListeners.values()) {
                    entry.call(this, new Event('stop'));
                }
                ;
            }));
            this.addEventListener = (type, listener) => {
                if (type === 'dataavailable') {
                    this._dataAvailableListeners.add(listener);
                    return;
                }
                if (type === 'stop') {
                    this._stopListeners.add(listener);
                    return;
                }
                super.addEventListener(type, listener);
            };
            this.removeEventListener = (type, listener) => {
                if (type === 'dataavailable') {
                    this._dataAvailableListeners.delete(listener);
                    return;
                }
                if (type === 'stop') {
                    this._stopListeners.delete(listener);
                    return;
                }
                super.removeEventListener(type, listener);
            };
        }
    }
    set onstop(v) {
        if (this._needsConversion)
            this._onstop = v;
        else
            super.onstop = v;
    }
    get onstop() {
        if (this._needsConversion)
            return this._onstop;
        return super.onstop;
    }
    set ondataavailable(v) {
        if (this._needsConversion)
            this._ondataavailable = v;
        else
            super.ondataavailable = v;
    }
    get ondataavailable() {
        if (this._needsConversion)
            return this._ondataavailable;
        return super.ondataavailable;
    }
}
